document.addEventListener('DOMContentLoaded', () => {
  const verticalMenu = document.getElementById('vertical-nav-css');
  const secondMenu   = document.querySelector('.mega-hover_2');
  const overlay      = document.getElementById('menu-overlay');

  // Bail out if overlay is missing — or optionally check each menu’s existence before adding events.
  if (!overlay) return;

  // Helper functions
  function showOverlay() {
    overlay.classList.add('is-visible');
  }
  function hideOverlay() {
    overlay.classList.remove('is-visible');
  }

  // 1) Vertical menu events
  if (verticalMenu) {
    verticalMenu.addEventListener('mouseenter', showOverlay);
    verticalMenu.addEventListener('mouseleave', hideOverlay);
  }

  // 2) Second menu trigger with class .mega-hover_2
  if (secondMenu) {
    secondMenu.addEventListener('mouseenter', showOverlay);
    secondMenu.addEventListener('mouseleave', hideOverlay);
  }

  // (Optional) Hide overlay if user clicks anywhere on it
  overlay.addEventListener('click', hideOverlay);
});